module.exports = __webpack_public_path__ + "assets/img/frame-top-right.e020e319.png";